/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1NotificationMobileAppSharedSelectionSummary200,
  GetApiV1NotificationMobileAppSharedSelectionSummary401,
  GetApiV1NotificationMobileAppSharedSelectionSummary500,
  GetApiV1NotificationMobileAppSharedSelectionSummaryQueryParams,
  GetApiV1NotificationMobileAppSharedSelectionSummaryQueryResponse,
} from "../../types/notificationMobileAppController/GetApiV1NotificationMobileAppSharedSelectionSummary.ts";
import { notificationSelectionSummaryViewModelSchema } from "../notificationSelectionSummaryViewModelSchema.ts";

export const getApiV1NotificationMobileAppSharedSelectionSummaryQueryParamsSchema =
  z
    .object({
      ClassStudentIds: z.optional(
        z
          .array(z.coerce.number().int())
          .describe(
            "IDs das turmas selecionadas. Obrigatório quando IsAllClassStudents = false. Ignorado quando IsAllClassStudents = true.",
          ),
      ),
      EnrollmentStatus: z.optional(
        z
          .array(z.coerce.number().int())
          .describe(
            "Status de matrícula para filtrar os alunos. Obrigatório. Ao menos um valor deve ser informado. Enum EEnrollmentStatus: `1` = PaymentSelection, `2` = PaymentPending, `3` = ApprovalPending, `4` = Approved, `5` = Activating, `6` = Active, `7` = Transferred, `8` = TransferredInRegistration, `9` = Canceled, `10` = CanceledInRegistration, `11` = Rejected, `12` = FinishedWithPendencies, `13` = Finished, `14` = FinishedWithMonograph, `15` = FinishedWithCertificate, `16` = Blocked.",
          ),
      ),
      IsAllClassStudents: z.optional(
        z
          .boolean()
          .describe(
            "Quando true, considera todas as turmas ativas e ignora ClassStudentIds. Default: false.",
          ),
      ),
    })
    .optional() as unknown as ToZod<GetApiV1NotificationMobileAppSharedSelectionSummaryQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1NotificationMobileAppSharedSelectionSummary200Schema =
  z.lazy(
    () => notificationSelectionSummaryViewModelSchema,
  ) as unknown as ToZod<GetApiV1NotificationMobileAppSharedSelectionSummary200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1NotificationMobileAppSharedSelectionSummary401Schema =
  z.any() as unknown as ToZod<GetApiV1NotificationMobileAppSharedSelectionSummary401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1NotificationMobileAppSharedSelectionSummary500Schema =
  z.any() as unknown as ToZod<GetApiV1NotificationMobileAppSharedSelectionSummary500>;

export const getApiV1NotificationMobileAppSharedSelectionSummaryQueryResponseSchema =
  z.lazy(
    () => getApiV1NotificationMobileAppSharedSelectionSummary200Schema,
  ) as unknown as ToZod<GetApiV1NotificationMobileAppSharedSelectionSummaryQueryResponse>;
